export type UserType = "artist" | "partner";
export const Artist: UserType = "artist";
export const Partner: UserType = "partner";
